// import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RecaptchaFormsModule,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module
} from 'ng-recaptcha';

import { RECAPTCHA_LANGUAGE } from "ng-recaptcha";
import { SharedService } from './shared/shared.service';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ChangeDetectorRef, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { NdbxIconModule } from '@allianz/ngx-ndbx/icon';
import { HeaderComponent } from './components/header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfigInit } from './initializers/config-init';
import { LocalStorageService, NgxLocalStorageModule } from 'ngx-localstorage';
import { Details1Component } from './components/Step 1/details1/details1.component';
import { Details2Component } from './components/Step 1/details2/details2.component';
import { Details3Component } from './components/Step 1/details3/details3.component';
import { TokenInterceptor } from './auth/token.interceptor';
import { OfferComponent } from './components/Step 2/offer/offer.component';
import { Details4Component } from './components/Step 3/details4/details4.component';
import { Details5Component } from './components/Step 3/details5/details5.component';
import { FuelTypePipe } from './pipes/fuelType.pipe';
import { FilterModelByMakeAndTypePipe } from './pipes/filter-model-by-make-and-type.pipe';
import { FilterTypeByMakeAndModelPipe } from './pipes/filter-type-by-make-and-model.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { TotalPriceComponent } from './components/total-price/total-price.component';
import { LangChangeEvent, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingComponent } from './components/loading/loading.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { MainComponent } from './components/main/main.component';
import { ErrorComponent } from './components/error/error.component';
import { BackArrowComponent } from './components/back-arrow/back-arrow.component';
import { CloseBannerDirective } from './directives/close-banner.directive';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { ValueAccessorPipe } from './pipes/value-accessor.pipe';
import { RegisteredCarComponent } from './components/registered-car/registered-car.component';
import { OrderComponent } from './components/order/order.component';
import { DisabledControlDirective } from './directives/disabled-control.directive';
import { CurrencyExchangePipe } from './pipes/currency-exchange.pipe';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeUs from '@angular/common/locales/es-US';
import { PackageRisksPipe } from './pipes/packageRisks.pipe';
import { PackagesTableComponent } from './components/Step 2/packages-table/packages-table.component';
import { OnlyMtplPipe } from './pipes/onlyMtpl.pipe';
import { FilterPaymentPlansPipe } from './pipes/filter-payment-plans.pipe';
import { OwnerDetailsComponent } from './components/owner-details/owner-details.component';
import { PolicyholderDetailsComponent } from './components/policyholder-details/policyholder-details.component';
import { ConsentsComponent } from './components/consents/consents.component';
import { PersonDetailsModalComponent } from './person-details-modal/person-details-modal.component';
import { BankTransformPipe } from './pipes/bank-transform.pipe';
import { FormControlNameDirective } from './directives/form-control-name.directive';
import { AuthService } from './auth/auth.service';
import { DateFieldAccessibilityDirective } from './directives/date-field-accessibility.directive';
import { ReversePipe } from './pipes/reverse.pipe';
import { PostCodesDirective } from './directives/post-codes.directive';
import { CorrespondenceAddressDirective } from './directives/correspondence-address.directive';
import { SelectedPlanPipe } from './pipes/selected-plan.pipe';
import { NgxCaptchaModule } from 'ngx-captcha';
import { YearRangePipe } from './pipes/year-range.pipe';
import { FilterPropertySubcategoriesPipe } from './pipes/filter-property-subcategories.pipe';
import { FilterSubcategoryByForIdPipe } from './pipes/filter-subcategory-by-for-id.pipe';
import { FilterCitiesByPostCodePipe } from './pipes/filter-cities-by-post-code.pipe';
import { SetPropertySubcategoryLabelDirective } from './directives/set-property-subcategory-label.directive';
import { IConfig, NgxMaskModule } from "ngx-mask";
import { ConvertPremiumsPipe } from './pipes/convert-premiums.pipe';
import { DataSummaryComponent } from './components/data-summary/data-summary.component';
import { InsuredSumModalComponent } from './insured-sum-modal/insured-sum-modal.component';
import { environment } from '../environments/environment';
import { TrackifyWindow } from '@allianz/tracking/models/trackify.model';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QbeComponentsModule } from 'qbe-components';
import { NxPhoneInputModule } from '@aposin/ng-aquila/phone-input';

// Allianz AEM
import {
  EmbeddedDataModule,
  EmbeddedDataService,
  NORMALIZE_URL_SERVICE_CONFIG_TOKEN,
  NormalizeUrlModule,
  NormalizeUrlService
} from '@allianz/ngx-aem-integration'

import { APP_BASE_HREF } from '@angular/common';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ConsentPopUpComponent } from './components/consent-pop-up/consent-pop-up.component';
import { InvalidControlScrollDirective } from './directives/invalid-control-scroll.directive';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { TrackService } from './services/track.service';
import { EvrotrustGeneralComponent } from './components/evrotrust/evrotrust-general/evrotrust-general.component';
import { SignPolicyModalComponent } from './components/evrotrust/sign-policy-modal/sign-policy-modal.component';
import { DownloadEvrotrustModalComponent } from './components/evrotrust/download-evrotrust-modal/download-evrotrust-modal.component';
import { PriceFormatPipe } from './pipes/priceFormat.pipe';
import { NxTableModule } from '@aposin/ng-aquila/table';import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { PriceFormatInsSumPipe } from './pipes/priceFormatInsSum.pipe';
import { NX_DATE_LOCALE } from '@aposin/ng-aquila/datefield';
import { NdbxModule } from './modules/ndbx.module';
import { PhoneNumbersComponent } from './components/phone-numbers/phone-numbers.component';

registerLocaleData(localeFr);
registerLocaleData(localeDe);
registerLocaleData(localeUs);

export function HttpLoaderFactory(http: HttpClient, normalizeUrlService: NormalizeUrlService) {
  const baseURL = normalizeUrlService.normalizeUrl('/assets/i18n/');
  return new TranslateHttpLoader(http, baseURL, '.json');
}

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
declare const window: TrackifyWindow;

export function loadTrackifyCustomMapping() {
  return () => {
    const trackingPathMapping = {
      'spaData.qbhome.applicationid': 'application.Id',
      'spaData.qbhome.virtualPageName': 'application.virtualPageName',
      'spaData.qbhome.previousVirtualPageName': 'application.previousVirtualPageName',
      'spaData.qbhome.eventLabel': 'event.label',
      'spaData.qbhome.01..navigationLink': 'navigationLink',
      'spaData.qbhome.pageChanged.oldPage': 'process.PreviousStepNumber'
    };
    if (!window.trackifyDefines) {
      // be safe to not override custom settings done by a tracking expert
      window.trackifyDefines = trackingPathMapping;
    } else {
      // merge with custom settings done by a tracking expert
      // using this order, Angular custom mapping potentially overrides an existing rewrite for an event name setup in Launch
      window.trackifyDefines = Object.assign(window.trackifyDefines, trackingPathMapping);
      // if we want the Launch custom mappings to be taken with higher relevance:
      // window.trackifyDefines = Object.assign(trackingPathMapping, window.trackifyDefines);
    }
  };
}

const aemModules = [NormalizeUrlModule]

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    Details1Component,
    Details2Component,
    Details3Component,
    OfferComponent,
    Details4Component,
    Details5Component,
    FuelTypePipe,
    FilterModelByMakeAndTypePipe,
    FilterTypeByMakeAndModelPipe,
    FooterComponent,
    TotalPriceComponent,
    LoadingComponent,
    GeneralInformationComponent,
    MainComponent,
    ErrorComponent,
    BackArrowComponent,
    CloseBannerDirective,
    InvalidControlScrollDirective,
    ValueAccessorPipe,
    RegisteredCarComponent,
    OrderComponent,
    DisabledControlDirective,
    CurrencyExchangePipe,
    PackageRisksPipe,
    PackagesTableComponent,
    OnlyMtplPipe,
    FilterPaymentPlansPipe,
    OwnerDetailsComponent,
    PolicyholderDetailsComponent,
    ConsentsComponent,
    PersonDetailsModalComponent,
    BankTransformPipe,
    FormControlNameDirective,
    DateFieldAccessibilityDirective,
    ReversePipe,
    PostCodesDirective,
    CorrespondenceAddressDirective,
    SelectedPlanPipe,
    YearRangePipe,
    FilterPropertySubcategoriesPipe,
    FilterSubcategoryByForIdPipe,
    FilterCitiesByPostCodePipe,
    SetPropertySubcategoryLabelDirective,
    ConvertPremiumsPipe,
    DataSummaryComponent,
    InsuredSumModalComponent,
    SafeHtmlPipe,
    PriceFormatPipe,
    PriceFormatInsSumPipe,
    ConsentPopUpComponent,
    EvrotrustGeneralComponent,
    SignPolicyModalComponent,
    DownloadEvrotrustModalComponent,
    PhoneNumbersComponent
  ],
  imports: [
    // AuthModule,
    NgxWebstorageModule.forRoot(),
    NormalizeUrlModule.forRoot({
      provide: NORMALIZE_URL_SERVICE_CONFIG_TOKEN,
      useValue: {
        deployUrl: environment.DEPLOY_URL,
      },
    }),
    EmbeddedDataModule.forRoot({
      rootElementTagName: 'seed-root',
      AssetsBasePath: '/assets',
    }),
    BrowserModule,
    BrowserAnimationsModule,
    NxTableModule,
    HttpClientModule,
    AppRoutingModule,
    NgxLocalStorageModule.forRoot(),
    QbeComponentsModule,
    FormsModule,
    DigitOnlyModule,
    NdbxIconModule,
    NdbxModule,
    ReactiveFormsModule,
    NdbxIconModule,
    NgxCaptchaModule,
    NxPhoneInputModule,
    // RecaptchaV3Module,
    TranslateModule.forRoot({
      defaultLanguage: 'bg',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, NormalizeUrlService]
      }
    }),
    NgxMaskModule.forRoot(),
    // NxNativeDateModule,
    ...aemModules,
    RecaptchaV3Module,
    RecaptchaModule,
    RecaptchaFormsModule,
    // EmbeddedDataModule.forRoot({
    //   rootElementTagName: 'app-root',
    //   AssetsBasePath: '/assets',
    // })
  ],
  providers: [
    AuthService,

    // {provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'},
    // {provide: NX_DATE_FORMATS, useValue: MY_FORMATS},
    // {provide: datepickerIntl, useClass: MyIntl},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    { provide: APP_BASE_HREF, useValue: environment.APP_BASE_HREF },
    {
      provide: LOCALE_ID,
      useValue: 'en-US'
    },
    {
      provide: NX_DATE_LOCALE,
      useValue: 'bg-BG'
    },
    TranslateService,
    LocalStorageService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadTrackifyCustomMapping,
      multi: true
    },
    HttpClient,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigInit,
      multi: true,
      deps: [HttpClient, LocalStorageService, AuthService]
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      //Not working - unnown why
      //Allianz:
      useValue: "6LfaMccZAAAAAKWfVv9idpDAqDL7G9ZLm3s1Jb1i"

      // test-dummy
      // useValue: "6LcYUIQeAAAAALkfybDBtYDA6j75T8pWb0TpyDOf"
      // useValue: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    },
    // { provide: RECAPTCHA_V3_SITE_KEY,
    //   useValue: "6LfaMccZAAAAAKWfVv9idpDAqDL7G9ZLm3s1Jb1i" },
    // { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
    // 6LcYUIQeAAAAALkfybDBtYDA6j75T8pWb0TpyDOf
    // {
    //   provide: RECAPTCHA_SETTINGS,
    //   useValue: {
    //     siteKey: "6LcYUIQeAAAAAKTB2tzVRfT0rPB5NZ0hpBhFYDbF"
    //     // siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    //   } as RecaptchaSettings
    // }
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        // Test
        // siteKey: "6LfaMccZAAAAAKWfVv9idpDAqDL7G9ZLm3s1Jb1i"
        // Allianz v2
        siteKey: "6LcicqkeAAAAAAQBYCBfNJONMFs90lObphrgyTUp"
        //test:
        // siteKey: "6LcN4ZEeAAAAAGFfZPKJU0vwaenzrykJXjkHoUaz",
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: "bg",

      // useFactory: (locale: string) => locale,
      // deps: [LOCALE_ID],
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private translateService: TranslateService, private localStorage: LocalStorageService, public sharedService: SharedService, public normalizeUrlService: NormalizeUrlService, public trackService: TrackService) {
    if(this.localStorage.get('language')){
      this.translateService.use(this.localStorage.get('language'));
    }
    else {
      this.localStorage.set('language', 'bg');
    }
    console.log(environment.DEPLOY_URL)
    translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.localStorage.set('language', event.lang);
      if(event.lang === 'bg'){
        this.trackService.pushEventTracking('language', 'Bulgarian')
      }
      else if(event.lang === 'en'){
        this.trackService.pushEventTracking('language', 'English')
      }
      this.sharedService.updateEnums(normalizeUrlService);
    });
  }
}
